import React from 'react';
import { useSelector } from 'react-redux';
import Image from 'next/image';
import CampaingCard from '../CampaignCard';
import { Campaign } from '@/store/reducers/Campaign/campaignSlice';
import { AppState } from '@/store/store';
import NoResult from '@/assets/icons/noresult.svg';
interface Props {
  title?: any;
  data: Campaign[];
}
const Campaings: React.FC<Props> = ({ title, data }) => {
  const { cities } = useSelector((state: AppState) => state.campaign);

  return (
    <div className={'flex items-center flex-col rounded-lg border-gray'}>
      {title ? <div className='self-start'>{title}</div> : null}

      <div
        className={
          'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 max-w-max gap-7'
        }
      >
        {data.length > 0 ? (
          data.map((campaign: Campaign) => {
            return (
              <CampaingCard
                key={campaign.slug}
                campaign={campaign}
                cities={cities}
              />
            );
          })
        ) : (
          <div className='flex flex-col justify-center items-center col-span-3 mt-20'>
            <Image
              src={NoResult}
              alt='NoResult'
              layout='fixed'
              width={128}
              height={128}
              className={'drop-shadow-md'}
            />
            <p className='mt-5 text-[12px] text-[#9B9B9B]'>
              Aradığınız kriterlere uygun sonuç bulunamamıştır.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Campaings;
